import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601DateTime: any;
  JSON: any;
};

export type ApiToken = {
  __typename?: 'ApiToken';
  createdAt: Scalars['ISO8601DateTime'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  transient?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['Int'];
};

export type Association = {
  __typename?: 'Association';
  ams?: Maybe<Scalars['String']>;
  branding?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ramcoApiKey?: Maybe<Scalars['String']>;
  ramcoCustomFields?: Maybe<Scalars['JSON']>;
  rapattoniClientId?: Maybe<Scalars['String']>;
  rapattoniCustomer?: Maybe<Scalars['String']>;
  thinkificApiKey?: Maybe<Scalars['String']>;
  thinkificSubdomain?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  users: Array<User>;
};

/** The connection type for Association. */
export type AssociationConnection = {
  __typename?: 'AssociationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssociationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Association>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated input type of AssociationCustomFieldsSave */
export type AssociationCustomFieldsSaveInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fields: Scalars['JSON'];
};

/** Autogenerated return type of AssociationCustomFieldsSave */
export type AssociationCustomFieldsSavePayload = {
  __typename?: 'AssociationCustomFieldsSavePayload';
  association: Association;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type AssociationEdge = {
  __typename?: 'AssociationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Association>;
};

export type CalendarItem = {
  __typename?: 'CalendarItem';
  allowGroupRegistrations?: Maybe<Scalars['Boolean']>;
  ams?: Maybe<Association>;
  amsPrimaryKey?: Maybe<Scalars['String']>;
  amsType?: Maybe<Scalars['String']>;
  associationId: Scalars['Int'];
  attendanceFinalizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  availableToMemberTypes?: Maybe<Scalars['String']>;
  beginDate?: Maybe<Scalars['ISO8601DateTime']>;
  beginTime?: Maybe<Scalars['String']>;
  cancellations?: Maybe<Array<Registration>>;
  checkinCount: Scalars['Int'];
  checkins?: Maybe<Array<Registration>>;
  checkoutCount: Scalars['Int'];
  checkouts?: Maybe<Array<Registration>>;
  classType?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  customFields?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  externalRegistrationLink?: Maybe<Scalars['String']>;
  fees?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  instructor?: Maybe<Scalars['JSON']>;
  location?: Maybe<Scalars['JSON']>;
  maxRegistrations?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  outsideProvider?: Maybe<Scalars['Boolean']>;
  outsideProviderLink?: Maybe<Scalars['String']>;
  outsideProviderMessage?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  ramcoCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  ramcoEntityId?: Maybe<Scalars['String']>;
  ramcoEntityType?: Maybe<Scalars['String']>;
  ramcoUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  registration?: Maybe<Registration>;
  registrations?: Maybe<Array<Registration>>;
  requiredCheckinCount?: Maybe<Scalars['Int']>;
  rialtoCourseType?: Maybe<Scalars['String']>;
  rialtoMaterialsLink?: Maybe<Scalars['String']>;
  rialtoSponsorArtLink?: Maybe<Scalars['String']>;
  rialtoSurveyLink?: Maybe<Scalars['String']>;
  rialtoTemplate?: Maybe<Scalars['JSON']>;
  sponsors?: Maybe<Scalars['JSON']>;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  thinkificBundleId?: Maybe<Scalars['Int']>;
  thinkificCourse?: Maybe<ThinkificCourse>;
  thinkificCourseId?: Maybe<Scalars['Int']>;
  thinkificPrototypeId?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  totalRegistrations?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};

/** The connection type for CalendarItem. */
export type CalendarItemConnection = {
  __typename?: 'CalendarItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CalendarItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CalendarItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CalendarItemEdge = {
  __typename?: 'CalendarItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CalendarItem>;
};

/** Autogenerated input type of Checkin */
export type CheckinInput = {
  checkinDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
  index: Scalars['Int'];
};

/** Autogenerated return type of Checkin */
export type CheckinPayload = {
  __typename?: 'CheckinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

export type Checkout = {
  __typename?: 'Checkout';
  address?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  checkoutToken?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  jobStartedAt?: Maybe<Scalars['ISO8601DateTime']>;
  last4?: Maybe<Scalars['String']>;
  lineItems: Array<CheckoutLineItem>;
  name?: Maybe<Scalars['String']>;
  narAssociationId?: Maybe<Scalars['String']>;
  narAssociationRequestId?: Maybe<Scalars['String']>;
  narEcControlNumber?: Maybe<Scalars['String']>;
  narResultCode?: Maybe<Scalars['String']>;
  narResultMessage?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of Checkout */
export type CheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
};

export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  amount: Scalars['Float'];
  event: CalendarItem;
  fee?: Maybe<Scalars['JSON']>;
};

/** Autogenerated return type of Checkout */
export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

/** Autogenerated input type of ClearCheckin */
export type ClearCheckinInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
};

/** Autogenerated return type of ClearCheckin */
export type ClearCheckinPayload = {
  __typename?: 'ClearCheckinPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

/** Autogenerated input type of ClearCheckout */
export type ClearCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
};

/** Autogenerated return type of ClearCheckout */
export type ClearCheckoutPayload = {
  __typename?: 'ClearCheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

/** Autogenerated input type of ClearRamcoAttendance */
export type ClearRamcoAttendanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
};

/** Autogenerated return type of ClearRamcoAttendance */
export type ClearRamcoAttendancePayload = {
  __typename?: 'ClearRamcoAttendancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

/** Autogenerated input type of CreateCheckout */
export type CreateCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: EcommerceCheckoutInput;
};

/** Autogenerated return type of CreateCheckout */
export type CreateCheckoutPayload = {
  __typename?: 'CreateCheckoutPayload';
  checkout: Checkout;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Autogenerated input type of CreateThinkificLogin */
export type CreateThinkificLoginInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateThinkificLogin */
export type CreateThinkificLoginPayload = {
  __typename?: 'CreateThinkificLoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  howHear?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  license?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
};

export type EcommerceCheckoutInput = {
  address: Scalars['String'];
  associationId: Scalars['ID'];
  cardNumber: Scalars['String'];
  city: Scalars['String'];
  cvv: Scalars['String'];
  email: Scalars['String'];
  expiration: Scalars['String'];
  lineItems: Array<EcommerceLineItemInput>;
  name: Scalars['String'];
  postal: Scalars['String'];
  returnUrl: Scalars['String'];
  state: Scalars['String'];
};

export type EcommerceLineItemInput = {
  eventId: Scalars['ID'];
  feeId: Scalars['String'];
  quantity: Scalars['Int'];
};

/** Autogenerated input type of FinalizeRamcoAttendance */
export type FinalizeRamcoAttendanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['Int']>;
};

/** Autogenerated return type of FinalizeRamcoAttendance */
export type FinalizeRamcoAttendancePayload = {
  __typename?: 'FinalizeRamcoAttendancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registrations: Array<Registration>;
};

/** Autogenerated input type of GenerateUserToken */
export type GenerateUserTokenInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['String'];
};

/** Autogenerated return type of GenerateUserToken */
export type GenerateUserTokenPayload = {
  __typename?: 'GenerateUserTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  jwt: Scalars['String'];
};

/** Autogenerated input type of HandleScanResult */
export type HandleScanResultInput = {
  associationId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['String'];
  eventId: Scalars['String'];
};

/** Autogenerated return type of HandleScanResult */
export type HandleScanResultPayload = {
  __typename?: 'HandleScanResultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registration: Registration;
};

/** Autogenerated input type of InviteUser */
export type InviteUserInput = {
  associationId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** Autogenerated return type of InviteUser */
export type InviteUserPayload = {
  __typename?: 'InviteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of LinkEventToThinkific */
export type LinkEventToThinkificInput = {
  bundleId?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  thinkificId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LinkEventToThinkific */
export type LinkEventToThinkificPayload = {
  __typename?: 'LinkEventToThinkificPayload';
  calendarItem: CalendarItem;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of Login */
export type LoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  token: ApiToken;
};

export type Member = {
  __typename?: 'Member';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  checkin?: Maybe<CheckinPayload>;
  checkout?: Maybe<CheckoutPayload>;
  clearCheckin?: Maybe<ClearCheckinPayload>;
  clearCheckout?: Maybe<ClearCheckoutPayload>;
  clearRamcoAttendance?: Maybe<ClearRamcoAttendancePayload>;
  createCheckout?: Maybe<CreateCheckoutPayload>;
  createThinkificLogin?: Maybe<CreateThinkificLoginPayload>;
  finalizeRamcoAttendance?: Maybe<FinalizeRamcoAttendancePayload>;
  generateUserToken?: Maybe<GenerateUserTokenPayload>;
  handleScanResult?: Maybe<HandleScanResultPayload>;
  inviteUser?: Maybe<InviteUserPayload>;
  linkEventToThinkific?: Maybe<LinkEventToThinkificPayload>;
  login?: Maybe<LoginPayload>;
  ramcoCreateUser?: Maybe<RamcoCreateUserPayload>;
  ramcoLogin?: Maybe<RamcoLoginPayload>;
  refreshCalendarFromAms?: Maybe<RefreshCalendarFromAmsPayload>;
  registerRamco?: Maybe<RegisterRamcoPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  saveAssociationCustomFields?: Maybe<AssociationCustomFieldsSavePayload>;
  sendLoginCode?: Maybe<SendLoginCodePayload>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  ssoLogin?: Maybe<SsoLoginPayload>;
  updateBranding?: Maybe<UpdateBrandingPayload>;
  updateClassCheckinCount?: Maybe<UpdateClassCheckinCountPayload>;
  updateLogo?: Maybe<UpdateLogoPayload>;
  updateRamcoContact?: Maybe<UpdateRamcoContactPayload>;
  verifyLoginCode?: Maybe<VerifyLoginCodePayload>;
};


export type MutationCheckinArgs = {
  input: CheckinInput;
};


export type MutationCheckoutArgs = {
  input: CheckoutInput;
};


export type MutationClearCheckinArgs = {
  input: ClearCheckinInput;
};


export type MutationClearCheckoutArgs = {
  input: ClearCheckoutInput;
};


export type MutationClearRamcoAttendanceArgs = {
  input: ClearRamcoAttendanceInput;
};


export type MutationCreateCheckoutArgs = {
  input: CreateCheckoutInput;
};


export type MutationCreateThinkificLoginArgs = {
  input: CreateThinkificLoginInput;
};


export type MutationFinalizeRamcoAttendanceArgs = {
  input: FinalizeRamcoAttendanceInput;
};


export type MutationGenerateUserTokenArgs = {
  input: GenerateUserTokenInput;
};


export type MutationHandleScanResultArgs = {
  input: HandleScanResultInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLinkEventToThinkificArgs = {
  input: LinkEventToThinkificInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRamcoCreateUserArgs = {
  input: RamcoCreateUserInput;
};


export type MutationRamcoLoginArgs = {
  input: RamcoLoginInput;
};


export type MutationRefreshCalendarFromAmsArgs = {
  input: RefreshCalendarFromAmsInput;
};


export type MutationRegisterRamcoArgs = {
  input: RegisterRamcoInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveAssociationCustomFieldsArgs = {
  input: AssociationCustomFieldsSaveInput;
};


export type MutationSendLoginCodeArgs = {
  input: SendLoginCodeInput;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type MutationSsoLoginArgs = {
  input: SsoLoginInput;
};


export type MutationUpdateBrandingArgs = {
  input: UpdateBrandingInput;
};


export type MutationUpdateClassCheckinCountArgs = {
  input: UpdateClassCheckinCountInput;
};


export type MutationUpdateLogoArgs = {
  input: UpdateLogoInput;
};


export type MutationUpdateRamcoContactArgs = {
  input: UpdateRamcoContactInput;
};


export type MutationVerifyLoginCodeArgs = {
  input: VerifyLoginCodeInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  association?: Maybe<Association>;
  associations: AssociationConnection;
  calendarItem?: Maybe<CalendarItem>;
  calendarItems: CalendarItemConnection;
  currentUser?: Maybe<User>;
  describeRamcoEntity?: Maybe<RamcoEntityDescription>;
  member?: Maybe<RamcoMemberContact>;
  members?: Maybe<RamcoMemberContactConnection>;
  office?: Maybe<RamcoMemberOffice>;
  offices: RamcoMemberOfficeConnection;
  ramcoCheckout?: Maybe<Checkout>;
  ramcoSetupReport?: Maybe<RamcoSetupReport>;
  searchMembers?: Maybe<Array<Member>>;
  thinkificCourses?: Maybe<ThinkificCourseConnection>;
  topTags: Array<Scalars['String']>;
};


export type QueryAssociationArgs = {
  id: Scalars['ID'];
};


export type QueryAssociationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCalendarItemArgs = {
  id: Scalars['ID'];
};


export type QueryCalendarItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  associationId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  beginDateGt?: InputMaybe<Scalars['ISO8601DateTime']>;
  beginDateLt?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  published?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};


export type QueryDescribeRamcoEntityArgs = {
  associationId: Scalars['ID'];
  entityName: Scalars['String'];
};


export type QueryMemberArgs = {
  id: Scalars['ID'];
};


export type QueryMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  associationId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryOfficeArgs = {
  id: Scalars['ID'];
};


export type QueryOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  associationId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRamcoCheckoutArgs = {
  token: Scalars['String'];
};


export type QueryRamcoSetupReportArgs = {
  associationId: Scalars['ID'];
};


export type QuerySearchMembersArgs = {
  associationId: Scalars['ID'];
  query: Scalars['String'];
};


export type QueryThinkificCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  associationId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTopTagsArgs = {
  associationId: Scalars['ID'];
};

/** Autogenerated input type of RamcoCreateUser */
export type RamcoCreateUserInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: CreateUserInput;
};

/** Autogenerated return type of RamcoCreateUser */
export type RamcoCreateUserPayload = {
  __typename?: 'RamcoCreateUserPayload';
  authToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type RamcoEntityDescription = {
  __typename?: 'RamcoEntityDescription';
  fields: Array<RamcoField>;
};

export type RamcoField = {
  __typename?: 'RamcoField';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RamcoLogin */
export type RamcoLoginInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};

/** Autogenerated return type of RamcoLogin */
export type RamcoLoginPayload = {
  __typename?: 'RamcoLoginPayload';
  authToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type RamcoMemberContact = {
  __typename?: 'RamcoMemberContact';
  address?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  associationId: Scalars['Int'];
  balance?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  designation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['ISO8601DateTime']>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  headshotKey?: Maybe<Scalars['String']>;
  headshotUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  memberType?: Maybe<Scalars['JSON']>;
  mls?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  office?: Maybe<RamcoMemberOffice>;
  officeId?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  ramcoEntityId?: Maybe<Scalars['String']>;
  serviceProvided?: Maybe<ServiceProvided>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  username?: Maybe<Scalars['String']>;
};

/** The connection type for RamcoMemberContact. */
export type RamcoMemberContactConnection = {
  __typename?: 'RamcoMemberContactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RamcoMemberContactEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RamcoMemberContact>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RamcoMemberContactEdge = {
  __typename?: 'RamcoMemberContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RamcoMemberContact>;
};

export type RamcoMemberContactInput = {
  address?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type RamcoMemberOffice = {
  __typename?: 'RamcoMemberOffice';
  address?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  associationId: Scalars['Int'];
  city?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<RamcoMemberContact>>;
  createdAt: Scalars['ISO8601DateTime'];
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  officeContactId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  ramcoEntityId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
};

/** The connection type for RamcoMemberOffice. */
export type RamcoMemberOfficeConnection = {
  __typename?: 'RamcoMemberOfficeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RamcoMemberOfficeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RamcoMemberOffice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RamcoMemberOfficeEdge = {
  __typename?: 'RamcoMemberOfficeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RamcoMemberOffice>;
};

export type RamcoSetupReport = {
  __typename?: 'RamcoSetupReport';
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of RefreshCalendarFromAms */
export type RefreshCalendarFromAmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of RefreshCalendarFromAms */
export type RefreshCalendarFromAmsPayload = {
  __typename?: 'RefreshCalendarFromAmsPayload';
  calendarItem: CalendarItem;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RegisterRamco */
export type RegisterRamcoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feeId: Scalars['ID'];
  id: Scalars['ID'];
};

/** Autogenerated return type of RegisterRamco */
export type RegisterRamcoPayload = {
  __typename?: 'RegisterRamcoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  registration: Registration;
};

export type Registration = {
  __typename?: 'Registration';
  amsContactId?: Maybe<Scalars['String']>;
  amsRegistrationId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']>;
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']>;
  checkedOutAt?: Maybe<Scalars['ISO8601DateTime']>;
  checkinLog?: Maybe<Array<Maybe<Scalars['ISO8601DateTime']>>>;
  companionFirstName?: Maybe<Scalars['String']>;
  companionLastName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  couponId?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  event: CalendarItem;
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['Int']>;
  paymentErrorAt?: Maybe<Scalars['ISO8601DateTime']>;
  paymentErrorMessage?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  ramcoContactId?: Maybe<Scalars['String']>;
  ramcoCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  ramcoEntityId?: Maybe<Scalars['String']>;
  ramcoEntityType?: Maybe<Scalars['String']>;
  ramcoGrade?: Maybe<Scalars['String']>;
  ramcoRegistrationFeeId?: Maybe<Scalars['String']>;
  ramcoRegistrationId?: Maybe<Scalars['String']>;
  ramcoUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  refundAmount?: Maybe<Scalars['Float']>;
  refundId?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  statusCodeName?: Maybe<Scalars['String']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  stripeSessionId?: Maybe<Scalars['String']>;
  thinkificBundleId?: Maybe<Scalars['Int']>;
  thinkificCourseId?: Maybe<Scalars['Int']>;
  thinkificEnrollmentId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendLoginCode */
export type SendLoginCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of SendLoginCode */
export type SendLoginCodePayload = {
  __typename?: 'SendLoginCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SendPasswordResetEmail */
export type SendPasswordResetEmailInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

/** Autogenerated return type of SendPasswordResetEmail */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ServiceProvided = {
  __typename?: 'ServiceProvided';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SsoLogin */
export type SsoLoginInput = {
  associationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
};

/** Autogenerated return type of SsoLogin */
export type SsoLoginPayload = {
  __typename?: 'SsoLoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  redirectUrl: Scalars['String'];
};

export type ThinkificCourse = {
  __typename?: 'ThinkificCourse';
  associationId?: Maybe<Scalars['Int']>;
  chapters?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  thinkificId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ThinkificCourse. */
export type ThinkificCourseConnection = {
  __typename?: 'ThinkificCourseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ThinkificCourseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ThinkificCourse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ThinkificCourseEdge = {
  __typename?: 'ThinkificCourseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ThinkificCourse>;
};

/** Autogenerated input type of UpdateBranding */
export type UpdateBrandingInput = {
  associationId: Scalars['String'];
  brandColor: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateBranding */
export type UpdateBrandingPayload = {
  __typename?: 'UpdateBrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateClassCheckinCount */
export type UpdateClassCheckinCountInput = {
  checkinCount: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateClassCheckinCount */
export type UpdateClassCheckinCountPayload = {
  __typename?: 'UpdateClassCheckinCountPayload';
  calendarItem: CalendarItem;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateLogo */
export type UpdateLogoInput = {
  associationId: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  cloudinaryId: Scalars['String'];
};

/** Autogenerated return type of UpdateLogo */
export type UpdateLogoPayload = {
  __typename?: 'UpdateLogoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateRamcoContact */
export type UpdateRamcoContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: RamcoMemberContactInput;
};

/** Autogenerated return type of UpdateRamcoContact */
export type UpdateRamcoContactPayload = {
  __typename?: 'UpdateRamcoContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  user: User;
};

export type User = {
  __typename?: 'User';
  associationId?: Maybe<Scalars['ID']>;
  associations: Array<Association>;
  balance?: Maybe<Scalars['Float']>;
  contact?: Maybe<RamcoMemberContact>;
  createdAt: Scalars['ISO8601DateTime'];
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentSignInIp?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  encryptedPassword: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSignInIp?: Maybe<Scalars['String']>;
  priceLevelId?: Maybe<Scalars['ID']>;
  ramcoContactId?: Maybe<Scalars['ID']>;
  registrations: Array<Registration>;
  rememberCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  resetPasswordSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  signInCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  username: Scalars['String'];
};

/** Autogenerated input type of VerifyLoginCode */
export type VerifyLoginCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  email: Scalars['String'];
};

/** Autogenerated return type of VerifyLoginCode */
export type VerifyLoginCodePayload = {
  __typename?: 'VerifyLoginCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  token?: Maybe<ApiToken>;
};

export type LoginMutationVariables = Exact<{
  input: SsoLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', ssoLogin?: { __typename?: 'SsoLoginPayload', redirectUrl: string } | null };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateRamcoContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateRamcoContact?: { __typename?: 'UpdateRamcoContactPayload', user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, contact?: { __typename?: 'RamcoMemberContact', city?: string | null, address?: string | null, addressLineTwo?: string | null, state?: string | null, postal?: string | null, phone?: string | null, mobilePhone?: string | null, officePhone?: string | null, fax?: string | null } | null } } | null };

export type MemberFragmentFragment = { __typename?: 'RamcoMemberContact', id: string, firstName?: string | null, lastName?: string | null, mls?: string | null, address?: string | null, city?: string | null, postal?: string | null, state?: string | null, headshotUrl?: string | null, headshotKey?: string | null, memberType?: any | null, phone?: string | null, fax?: string | null, officePhone?: string | null, mobilePhone?: string | null, designation?: string | null, email?: string | null, serviceProvided?: { __typename?: 'ServiceProvided', id?: string | null, name?: string | null } | null, office?: { __typename?: 'RamcoMemberOffice', id: string, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postal?: string | null } | null };

export type CalendarItemsQueryVariables = Exact<{
  associationId: Scalars['ID'];
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type CalendarItemsQuery = { __typename?: 'Query', calendarItems: { __typename?: 'CalendarItemConnection', nodes?: Array<{ __typename?: 'CalendarItem', id: string, amsType?: string | null, tags?: Array<string> | null, amsPrimaryKey?: string | null, name?: string | null, location?: any | null, instructor?: any | null, summary?: string | null, description?: string | null, descriptionText?: string | null, beginDate?: any | null, endDate?: any | null, totalRegistrations?: number | null, customFields?: any | null, checkinCount: number, checkoutCount: number, thinkificCourse?: { __typename?: 'ThinkificCourse', id: string, name?: string | null, chapters?: any | null } | null, registration?: { __typename?: 'Registration', id: string } | null, ams?: { __typename?: 'Association', id: string, name?: string | null, ams?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, contact?: { __typename?: 'RamcoMemberContact', balance?: number | null, mls?: string | null, city?: string | null, address?: string | null, state?: string | null, postal?: string | null, phone?: string | null, mobilePhone?: string | null, officePhone?: string | null, fax?: string | null, headshotKey?: string | null, headshotUrl?: string | null } | null, registrations: Array<{ __typename?: 'Registration', id: string, event: { __typename?: 'CalendarItem', id: string, name?: string | null, beginDate?: any | null, amsType?: string | null, tags?: Array<string> | null, thinkificCourseId?: number | null, customFields?: any | null, location?: any | null } }> } | null };

export type MembersQueryVariables = Exact<{
  associationId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type MembersQuery = { __typename?: 'Query', members?: { __typename?: 'RamcoMemberContactConnection', nodes?: Array<{ __typename?: 'RamcoMemberContact', id: string, firstName?: string | null, lastName?: string | null, mls?: string | null, address?: string | null, city?: string | null, postal?: string | null, state?: string | null, headshotUrl?: string | null, headshotKey?: string | null, memberType?: any | null, phone?: string | null, fax?: string | null, officePhone?: string | null, mobilePhone?: string | null, designation?: string | null, email?: string | null, serviceProvided?: { __typename?: 'ServiceProvided', id?: string | null, name?: string | null } | null, office?: { __typename?: 'RamcoMemberOffice', id: string, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postal?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } } | null };

export type MemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type MemberQuery = { __typename?: 'Query', member?: { __typename?: 'RamcoMemberContact', id: string, firstName?: string | null, lastName?: string | null, mls?: string | null, address?: string | null, city?: string | null, postal?: string | null, state?: string | null, headshotUrl?: string | null, headshotKey?: string | null, memberType?: any | null, phone?: string | null, fax?: string | null, officePhone?: string | null, mobilePhone?: string | null, designation?: string | null, email?: string | null, serviceProvided?: { __typename?: 'ServiceProvided', id?: string | null, name?: string | null } | null, office?: { __typename?: 'RamcoMemberOffice', id: string, name?: string | null, address?: string | null, city?: string | null, state?: string | null, postal?: string | null } | null } | null };

export type OfficeQueryVariables = Exact<{
  officeId: Scalars['ID'];
}>;


export type OfficeQuery = { __typename?: 'Query', office?: { __typename?: 'RamcoMemberOffice', id: string, name?: string | null, phone?: string | null, fax?: string | null, url?: string | null, address?: string | null, city?: string | null, state?: string | null, postal?: string | null, contacts?: Array<{ __typename?: 'RamcoMemberContact', id: string, firstName?: string | null, designation?: string | null, lastName?: string | null, phone?: string | null, fax?: string | null, officePhone?: string | null, mobilePhone?: string | null }> | null } | null };

export type OfficesQueryVariables = Exact<{
  associationId: Scalars['ID'];
}>;


export type OfficesQuery = { __typename?: 'Query', offices: { __typename?: 'RamcoMemberOfficeConnection', nodes?: Array<{ __typename?: 'RamcoMemberOffice', name?: string | null, contacts?: Array<{ __typename?: 'RamcoMemberContact', firstName?: string | null, lastName?: string | null }> | null } | null> | null } };

export const MemberFragmentFragmentDoc = gql`
    fragment MemberFragment on RamcoMemberContact {
  id
  firstName
  lastName
  mls
  address
  city
  postal
  state
  headshotUrl
  headshotKey
  memberType
  phone
  fax
  officePhone
  mobilePhone
  designation
  email
  serviceProvided {
    id
    name
  }
  office {
    id
    name
    address
    city
    state
    postal
  }
}
    `;
export const LoginDocument = gql`
    mutation Login($input: SsoLoginInput!) {
  ssoLogin(input: $input) {
    redirectUrl
  }
}
    `;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateRamcoContactInput!) {
  updateRamcoContact(input: $input) {
    user {
      id
      firstName
      lastName
      email
      contact {
        city
        address
        addressLineTwo
        state
        postal
        phone
        mobilePhone
        officePhone
        fax
      }
    }
  }
}
    `;
export const CalendarItemsDocument = gql`
    query CalendarItems($associationId: ID!, $before: String, $after: String, $first: Int, $last: Int) {
  calendarItems(
    associationId: $associationId
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    nodes {
      id
      amsType
      tags
      amsPrimaryKey
      name
      location
      instructor
      summary
      description
      descriptionText
      beginDate
      endDate
      totalRegistrations
      customFields
      checkinCount
      checkoutCount
      thinkificCourse {
        id
        name
        chapters
      }
      registration {
        id
      }
      ams {
        id
        name
        ams
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    firstName
    lastName
    email
    contact {
      balance
      mls
      city
      address
      state
      postal
      phone
      mobilePhone
      officePhone
      fax
      headshotKey
      headshotUrl
    }
    registrations {
      id
      event {
        id
        name
        beginDate
        amsType
        tags
        thinkificCourseId
        customFields
        location
      }
    }
  }
}
    `;
export const MembersDocument = gql`
    query Members($associationId: ID!, $query: String, $before: String, $after: String, $first: Int, $last: Int) {
  members(
    associationId: $associationId
    query: $query
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    nodes {
      ...MemberFragment
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    ${MemberFragmentFragmentDoc}`;
export const MemberDocument = gql`
    query Member($memberId: ID!) {
  member(id: $memberId) {
    ...MemberFragment
  }
}
    ${MemberFragmentFragmentDoc}`;
export const OfficeDocument = gql`
    query Office($officeId: ID!) {
  office(id: $officeId) {
    id
    name
    phone
    fax
    url
    address
    city
    state
    postal
    contacts {
      id
      firstName
      designation
      lastName
      phone
      fax
      officePhone
      mobilePhone
    }
  }
}
    `;
export const OfficesDocument = gql`
    query Offices($associationId: ID!) {
  offices(associationId: $associationId) {
    nodes {
      name
      contacts {
        firstName
        lastName
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Login(variables: LoginMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Login', 'mutation');
    },
    UpdateContact(variables: UpdateContactMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactMutation>(UpdateContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateContact', 'mutation');
    },
    CalendarItems(variables: CalendarItemsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CalendarItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalendarItemsQuery>(CalendarItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalendarItems', 'query');
    },
    CurrentUser(variables?: CurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentUserQuery>(CurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CurrentUser', 'query');
    },
    Members(variables: MembersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MembersQuery>(MembersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Members', 'query');
    },
    Member(variables: MemberQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MemberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MemberQuery>(MemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Member', 'query');
    },
    Office(variables: OfficeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OfficeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeQuery>(OfficeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Office', 'query');
    },
    Offices(variables: OfficesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<OfficesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficesQuery>(OfficesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Offices', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;